var _circle, _circle2, _circle3, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgMaintainStation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 151,
    viewBox: "0 0 153 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 76.5,
    cy: 75.5,
    r: 70,
    stroke: "#FFD4D6",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.34,
    cx: 76.5,
    cy: 75.5,
    r: 75,
    stroke: "#FFD4D6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.5,
    cy: 75.5,
    r: 63.5,
    stroke: "#FFD4D6",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 75C16 41.8629 42.8629 15 76 15C109.137 15 136 41.8629 136 75C136 108.137 109.137 135 76 135C42.8629 135 16 108.137 16 75Z",
    fill: "#F8696E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9464 40H77.0536C78.7656 40 80.2143 41.4395 80.2143 43.1406V50.4688L83.9018 43.1406C88.9062 45.7578 92.4621 50.8613 92.7254 56.75H92.8571C94.5692 56.75 96.0179 58.1895 96.0179 59.8906C96.0179 61.7227 94.5692 63.0312 92.8571 63.0312H59.1429C57.2991 63.0312 55.9821 61.7227 55.9821 59.8906C55.9821 58.1895 57.2991 56.75 59.1429 56.75C59.5379 50.8613 62.9621 45.7578 67.9665 43.1406L71.7857 50.4688V43.1406C71.7857 41.4395 73.1027 40 74.9464 40ZM76 81.875C67.308 81.875 60.1964 75.5938 59.2746 67.2188H92.7254C91.6719 75.5938 84.5603 81.875 76 81.875ZM64.1473 86.0625H87.721C97.4665 86.0625 105.5 94.0449 105.5 103.729C105.5 105.561 103.92 107 102.076 107H49.7924C47.9487 107 46.5 105.561 46.5 103.729C46.5 94.0449 54.4018 86.0625 64.1473 86.0625Z",
    fill: "url(#paint0_linear_3970_300304)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3970_300304",
    x1: 76,
    y1: 40,
    x2: 76,
    y2: 107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgMaintainStation);
export default __webpack_public_path__ + "static/media/img_maintain_station.fbcf468e1f4185b2ff73805953a274ef.svg";
export { ForwardRef as ReactComponent };